"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const BoxesIcon = React.forwardRef(function BoxesIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref }, props, { children: _jsx("path", { d: "M4.44 5.263L2 8.513V19.89c0 .897.728 1.625 1.627 1.625h11.387c.898 0 1.626-.728 1.626-1.625V8.513l-2.44-3.25H4.44zM2 8.513h14.64m-8.342-3.25L10.11 3h9.512L22 6.168v11.086c0 .875-.71 1.584-1.585 1.584H16.79M15.863 6.79h5.765" }) })));
});
export default BoxesIcon;
//# sourceMappingURL=boxes.js.map